import { DocumentStatus } from "../enums/document-status";
import { DriverDocumentNotificationResult } from "../models/drivers/management/driver-document-notification.mode";
import { isExpired, isExpiringSoon } from "./license-status.helper";

export function notificationHandler(licenseDate: Date | string, pdpDate: Date | string): DriverDocumentNotificationResult {
  const documents = [
    { date: licenseDate, name: "License" },
    { date: pdpDate, name: "PDP" }
  ];

  let expiredCount = 0;
  let expiringSoonCount = 0;
  const statuses: DocumentStatus[] = [];

  documents.forEach(doc => {
    const isDocExpired = isExpired(doc.date);
    const isDocExpiringSoon = isExpiringSoon(doc.date);

    if (isDocExpired) {
      expiredCount++;
      statuses.push(DocumentStatus.Expired);
    } else if (isDocExpiringSoon) {
      expiringSoonCount++;
      statuses.push(DocumentStatus.ExpiringSoon);
    }
  });

  let message = '';
  const totalIssues = expiredCount + expiringSoonCount;

  if (expiredCount > 0 && expiringSoonCount > 0) {
    message = `${expiringSoonCount} expiring & ${expiredCount} expired document${expiredCount > 1 ? '(s)' : ''} `;
  } else if (expiredCount > 0) {
    message = `${expiredCount} document${expiredCount > 1 ? 's' : ''} expired`;
  } else if (expiringSoonCount > 0) {
    message = `${expiringSoonCount} document${expiringSoonCount > 1 ? 's' : ''} expiring soon`;
  }

  return {
    message,
    count: totalIssues,
    status: statuses
  };
}